export const MFA_ACTIONS = {
  SEND_MFA: 'SEND_MFA',
  SETUP_MFA: 'SETUP_MFA',
};

export const MFA_OTP_LENGTH = 6;
